import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import { PaymentDetailsDrawerDataType } from './payment-details-drawer.component';

export const usePaymentDetailsDrawer = () =>
  useDrawer<PaymentDetailsDrawerDataType>();
